import { Routes, Route } from "react-router-dom";
import { ContentType } from "../constants/enums/contentType";
import {
  HomePage,
  ContentPage,
  SignInPage,
  SignUpPage,
  AdvancedSearchPage,
  CollectionPage,
  UserReviewsPage,
  UserFavoritesPage,
  UserCollectionsPage,
  UserHistoryPage,
  UserFollowsPage,
  ContentReviewPage,
  ContentReviewListPage,
  CollectionsListPage,
  SettingsPage,
  AboutPage,
  NotFoundPage,
  UserPage,
  PersonPage,
  ContentDetailsPage,
} from "./lazyPages";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/signin" element={<SignInPage />} />

      {/* Content type routes */}
      <Route
        path="/movies"
        element={<ContentPage contentType={ContentType.MOVIE} />}
      />
      <Route
        path="/tv-shows"
        element={<ContentPage contentType={ContentType.TV_SHOW} />}
      />
      <Route
        path="/books"
        element={<ContentPage contentType={ContentType.BOOK} />}
      />
      <Route
        path="/comics"
        element={<ContentPage contentType={ContentType.COMICS} />}
      />
      <Route
        path="/games"
        element={<ContentPage contentType={ContentType.GAME} />}
      />

      {/* Content detail routes */}
      <Route path="/content/:contentId" element={<ContentDetailsPage />} />
      <Route path="/review/:reviewId" element={<ContentReviewPage />} />
      <Route
        path="/content/:contentId/reviews"
        element={<ContentReviewListPage />}
      />
      <Route
        path="/content/:contentId/collections"
        element={<CollectionsListPage />}
      />

      {/* Person routes */}
      <Route path="/persons/:id" element={<PersonPage />} />

      {/* Search routes */}
      <Route path="/advancedSearch" element={<AdvancedSearchPage />} />

      {/* Collection routes */}
      <Route path="/collection/:collectionId" element={<CollectionPage />} />

      {/* User routes */}
      <Route path="/users/:username" element={<UserPage />} />
      <Route path="/users/:username/reviews" element={<UserReviewsPage />} />
      <Route
        path="/users/:username/collections"
        element={<UserCollectionsPage />}
      />
      <Route path="/users/:username/history" element={<UserHistoryPage />} />
      <Route
        path="/users/:username/favorites"
        element={<UserFavoritesPage />}
      />
      <Route path="/users/:username/follows" element={<UserFollowsPage />} />

      {/* App routes */}
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/about" element={<AboutPage />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
